/* eslint-disable import/prefer-default-export */
import styled from "styled-components";
import { bpMax } from "theme";

export const Container = styled.div`
	margin: 4px 0 14px;
	border: 1px solid #e8e7ea;
	border-radius: 4px;
	display: flex;
	align-items: center;
	padding: 12px 14px;
	background: #f4f2f6;
	&:focus-within {
		background: #fff;
	}
	input {
		border: none;
		outline: none;
		margin-left: 4px;
		font-size: 14px;
		line-height: 20px;
		background: #f4f2f6;
		::placeholder {
			color: #8c8594;
		}
		flex: 1;
		&:focus {
			background: #fff;
		}
	}

	svg {
		height: 20px;
		width: 20px;
	}

	${bpMax.md} {
		padding: 12px;
		input {
			width: calc(100% - 28px);
		}
	}
`;
